import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_ARTFOURNISS_SCHEMA_LITERAL = {
    title: 'Schéma ArtFourniss',
    description: 'Décrit les spécificités tarifaires',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        AR_REF: { type: 'string' },
        AF_PRIXACH: { type: 'number' },
        AF_UNITE: { type: 'number' },
        AF_CONVERSION: { type: 'number' },
        AF_REMISE: { type: 'number' },
        AF_TYPEREM: { type: 'number' },
        CT_NUM: { type: 'string' },
        AF_QTEMONT: { type: 'number' },
        AF_CODEBARRE: { type: 'string' },
        AF_REFFOURNISS: { type: 'string' }
    },
    required: [ 'CBMARQ', 'AR_REF', 'AF_PRIXACH' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(F_ARTFOURNISS_SCHEMA_LITERAL);
export type RxFArtFournissDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_ARTFOURNISS_SCHEMA: RxJsonSchema<RxFArtFournissDocumentType> = F_ARTFOURNISS_SCHEMA_LITERAL;
